(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5978],{

/***/ 46961:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/images",
      function () {
        return __webpack_require__(58766);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_images; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Images.tsx

var Images = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mt-5",
                children: "Image and content"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mt-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-md-4 mb-4 mb-md-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://dummyimage.com/400x200/000/fff",
                            className: "img-fluid float-start w-100",
                            alt: "..."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-md-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Title"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Possimus modi, quod eaque natus dolor vero inventore eos distinctio est iusto, nisi eius molestias fugit perferendis unde odit blanditiis commodi. Reiciendis."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mt-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-md-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Title"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Possimus modi, quod eaque natus dolor vero inventore eos distinctio est iusto, nisi eius molestias fugit perferendis unde odit blanditiis commodi. Reiciendis."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-md-4 mb-4 mb-sm-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://dummyimage.com/400x200/000/fff",
                            className: "img-fluid float-start w-100",
                            alt: "..."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row mt-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 mb-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: "Responsive Image"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://dummyimage.com/1076x400/000/fff",
                            className: "img-fluid",
                            alt: "..."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-3",
                            children: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Amet enim soluta eveniet ipsa consequuntur commodi suscipit et quod. Beatae rerum quam commodi sed. Expedita modi fugit culpa. Atque, hic non."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Image caption"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                        className: "figure",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "https://dummyimage.com/1076x400/000/fff",
                                className: "figure-img img-fluid",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                className: "figure-caption",
                                children: "A caption example for the image."
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Image left/right"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://dummyimage.com/400x200/000/fff",
                            className: "img-fluid float-start mb-5 mb-sm-0",
                            alt: "..."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://dummyimage.com/400x200/000/fff",
                            className: "img-fluid float-end",
                            alt: "..."
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_Images = (Images);

;// CONCATENATED MODULE: ./pages/components/images.tsx


var Page = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Images"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Images, {})
        ]
    });
};
/* harmony default export */ var components_images = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(46961); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);